import('./bootstrap');

if (process.env.NODE_ENV === 'development' && module.hot) {
	module.hot.accept();
}
